/**
 * Product Sub-category Endpoints
 */

export const apiPostProductSubCategory = async (
  category: ProductSubCategoryCreateUpdate,
): Promise<AxiosResponse<ProductSubCategory>> => {
  return await userManagementAxiosInstance.post('subcategories', category);
};

export const apiGetProductSubCategories = async (
  limit: number = defaultLimit,
  offset: number = defaultOffset,
): Promise<AxiosResponse<PaginatedProductSubCategory>> => {
  return await userManagementAxiosInstance.get(`subcategories?limit=${limit}&offset=${offset}`);
};

export const apiGetProductSubCategory = async (
  id: string | number,
): Promise<AxiosResponse<ProductSubCategory>> => {
  return await userManagementAxiosInstance.get(`subcategories/id/${id}`);
};

export const apiPutProductSubCategory = async (
  category: ProductSubCategoryCreateUpdate,
): Promise<AxiosResponse<ProductSubCategory>> => {
  return await userManagementAxiosInstance.put(`subcategories/id/${category.id}`, category);
};

export const apiDeleteProductSubCategory = async (
  id: string | number,
): Promise<AxiosResponse<ProductSubCategory>> => {
  return await userManagementAxiosInstance.delete(`subcategories/id/${id}`);
};
